import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiKeyGeneratorService } from "../../api-key-generator.service";
import { ApiService } from "../../api.service";
import { TelehealthConsent } from "src/app/models/telehealth-consent.model";

@Injectable({
    providedIn: 'root'
  })
  export class TelehealthConsentHistoryService {

    private apiUrl: string;

    constructor (
      private api: ApiService,
      protected http: HttpClient,
      private _apiKeyService: ApiKeyGeneratorService
    ) {
      this.apiUrl = `${this.api.getRootApiUrl()}/shared/telehealth-consent`;
    }

    getTelehealthContentForm(examType: string) {
      return this.http.get<TelehealthConsent>(`${this.apiUrl}?examType=${examType}`, {
        headers: this._apiKeyService.getApiKeyHeaders()
      });
    }
  }
